(() => {
  'use strict';
  const configNode = document.getElementById('FultonsNatuzziCheckoutData');
  const core = window.FultonsNatuzziCheckoutCore;
  if (!configNode || !core || !window.FultonsNatuzziManifestLoader || window.FultonsNatuzziCheckout) return;
  let data;
  try { data = JSON.parse(configNode.textContent); } catch { return; }
  const records = new WeakMap();
  let loader;
  try { loader = window.FultonsNatuzziManifestLoader.create({ manifestUrl: new URL(data.manifestUrl, location.origin).href, productId: data.productId, currency: data.currency, vendor: data.vendor || 'Natuzzi Editions', fetch: window.fetch.bind(window) }); } catch { return; }
  const getNative = async (record, signal) => {
    const url = new URL(data.productUrl, location.origin);
    url.pathname = url.pathname.replace(/\/products\/[^/]+$/, '/products/' + record.nativeHandle);
    url.searchParams.set('variant', record.variantId);
    url.searchParams.set('section_id', 'fultons-natuzzi-purchase-state');
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal });
    if (!response.ok) throw new Error('native');
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const element = page.querySelector('[data-fultons-natuzzi-native]');
    if (!element) throw new Error('native');
    return JSON.parse(element.textContent);
  };
  function panelFor(root) {
    let panel = root.querySelector('[data-natuzzi-purchase]');
    if (panel) return panel;
    const target = root.querySelector('[data-natuzzi-italia-purchase-anchor]') || root.querySelector('#PortentoEnquireButton') || root.querySelector('.fultons-upholstery-configurator .fuc-enquire') || root.querySelector('[data-natuzzi-table-purchase-anchor]');
    const template = document.getElementById('FultonsNatuzziPurchaseTemplate');
    if (!target || !template) return null;
    target.before(template.content.cloneNode(true));
    if (target.matches('#PortentoEnquireButton,.fuc-enquire')) target.setAttribute('data-natuzzi-enquiry', '');
    return root.querySelector('[data-natuzzi-purchase]');
  }
  function display(root, match, message = '') {
    const panel = panelFor(root);
    if (!panel) return;
    const manifest = records.get(root)?.manifest;
    panel.hidden = !manifest?.onlineEnabled;
    const form = panel.querySelector('form');
    form.querySelector('[name="id"]').value = match?.canCheckout ? match.variantId : '';
    form.querySelector('[name="id"]').disabled = !match?.canCheckout;
    form.querySelector('[type="submit"]').disabled = !match?.canCheckout;
    const quantity = form.querySelector('[name="quantity"]');
    quantity.disabled = !match?.canCheckout;
    if (match?.quantityRule) {
      const rule = match.quantityRule;
      quantity.min = String(rule.min);
      quantity.step = String(rule.increment);
      if (rule.max === null) quantity.removeAttribute('max');
      else quantity.max = String(rule.max);
      if (!core.quantityAllowed(Number(quantity.value), rule)) quantity.value = String(rule.min);
    }
    panel.querySelector('[data-natuzzi-status]').textContent = message || (match?.reason === 'order-limit' ? data.strings.orderLimit : '');
    const details = panel.querySelector('[data-natuzzi-order-summary]');
    details.replaceChildren();
    for (const [key, value] of Object.entries(match?.record?.orderDetails || {})) {
      if (!data.labels[key]) continue;
      const dt = document.createElement('dt'), dd = document.createElement('dd');
      dt.textContent = data.labels[key]; dd.textContent = value; details.append(dt, dd);
    }
    for (const field of ['delivery', 'returns', 'payment']) panel.querySelector('[data-natuzzi-' + field + ']').textContent = manifest?.commercial?.[field] || '';
    if (/^\/(?!\/)/.test(manifest?.commercial?.accessGuideUrl || '')) panel.querySelector('[data-natuzzi-access-guide]').href = manifest.commercial.accessGuideUrl;
    root.dataset.natuzziCheckoutReady = String(Boolean(match?.canCheckout));
    refreshQuantity(root, match);
  }
  function refreshQuantity(root, match) {
    const panel = panelFor(root), form = panel?.querySelector('form');
    if (!form || !match?.canCheckout || root.dataset.natuzziCheckoutReady !== 'true') return;
    const quantity = Number(form.elements.quantity.value);
    const allowed = core.quantityAllowed(quantity, match.quantityRule);
    form.querySelector('[type="submit"]').disabled = !allowed;
    panel.querySelector('[data-natuzzi-status]').textContent = allowed ? '' :
      Number.isFinite(quantity) && match.pricePence * quantity >= 500000 ? data.strings.orderLimit : 'Choose a valid quantity.';
  }
  for (const type of ['input', 'change']) document.addEventListener(type, event => {
    const quantity = event.target;
    if (!quantity.matches?.('[data-natuzzi-purchase-form] [name="quantity"]')) return;
    const root = quantity.closest('.catalogue-proof,.pdp-refined'), state = root && records.get(root);
    if (state && !state.busy) refreshQuantity(root, state.match);
  });
  function reviewSelection(root, match, quantity, state) {
    const dialog = panelFor(root).querySelector('[data-natuzzi-review]');
    if (typeof dialog?.showModal !== 'function') throw new Error('review');
    const order = match.record.orderDetails || {};
    dialog.querySelector('[data-natuzzi-review-model]').textContent = order.model || '';
    const details = dialog.querySelector('[data-natuzzi-review-summary]');
    details.replaceChildren();
    for (const key of ['configuration', 'covering', 'feet', 'finish', 'dimensions', 'quantity']) {
      const value = key === 'quantity' ? String(quantity) : order[key];
      if (!value || !data.labels[key]) continue;
      const dt = document.createElement('dt'), dd = document.createElement('dd');
      dt.textContent = data.labels[key]; dd.textContent = value; details.append(dt, dd);
    }
    dialog.querySelector('[data-natuzzi-review-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }).format(match.pricePence * quantity / 100);
    return new Promise(resolve => {
      const confirm = dialog.querySelector('[data-natuzzi-review-confirm]');
      const edit = dialog.querySelector('[data-natuzzi-review-edit]');
      const finish = accepted => {
        confirm.removeEventListener('click', approve);
        edit.removeEventListener('click', cancel);
        dialog.removeEventListener('cancel', cancel);
        dialog.removeEventListener('close', cancel);
        state.cancelReview = null;
        if (dialog.open) dialog.close();
        resolve(accepted);
      };
      const approve = () => finish(true);
      const cancel = event => { event?.preventDefault(); finish(false); };
      state.cancelReview = cancel;
      confirm.addEventListener('click', approve);
      edit.addEventListener('click', cancel);
      dialog.addEventListener('cancel', cancel);
      dialog.addEventListener('close', cancel);
      dialog.showModal();
      dialog.querySelector('h2').focus();
    });
  }
  async function updateSelection(input, root) {
    if (!root || input?.productId !== data.productId) return;
    if (data.vendor === 'Natuzzi Italia' && input?.kind !== 'table') input = window.FultonsNatuzziItaliaPurchase?.normalise(input) || { ...input, complete: false };
    let state = records.get(root);
    if (!state) { state = { revision: 0, busy: false }; records.set(root, state); }
    state.cancelReview?.();
    state.abort?.abort();
    state.abort = new AbortController();
    state.input = structuredClone(input);
    state.revision += 1;
    const revision = state.revision;
    display(root, null, data.strings.checking);
    try {
      const source = await loader.load(input);
      if (!root.isConnected || state.revision !== revision) return;
      state.manifest = source;
      const selection = core.withFixedFeet(source, input);
      const match = core.find(source, selection);
      if (!match.matched) { display(root, match); return; }
      const native = await getNative(match.record, state.abort.signal);
      if (!root.isConnected || state.revision !== revision) return;
      state.match = core.resolve(source, selection, native);
      display(root, state.match);
    } catch (error) {
      if (state.revision === revision && error.name !== 'AbortError') display(root, null, data.strings.unavailable);
    }
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-natuzzi-purchase-form]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const root = form.closest('.catalogue-proof,.pdp-refined'), state = root && records.get(root);
    if (!state || state.busy || !form.reportValidity()) return;
    state.busy = true;
    const revision = state.revision, quantity = Number(form.elements.quantity.value);
    const manifest = state.manifest;
    const selection = core.withFixedFeet(manifest, state.input);
    display(root, null, data.strings.checking);
    let cartAttempted = false;
    try {
      const match = core.find(manifest, selection);
      if (!match.matched) throw new Error('selection');
      let native = await getNative(match.record);
      let resolved = core.resolve(manifest, selection, native);
      if (state.revision !== revision || !root.isConnected || data.currency !== 'GBP') throw new Error('changed');
      if (!resolved.canCheckout || !core.quantityAllowed(quantity, resolved.quantityRule)) throw new Error('selection');
      const reviewed = resolved;
      if (!await reviewSelection(root, reviewed, quantity, state)) {
        if (state.revision === revision && root.isConnected) {
          display(root, state.match);
          form.querySelector('[type="submit"]').focus();
        }
        return;
      }
      const cartResponse = await fetch(data.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('cart-check');
      const currentCart = await cartResponse.json();
      if (!core.cartWithinLimit(currentCart, resolved.pricePence, quantity)) throw new Error('order-limit');
      if (state.revision !== revision || !root.isConnected || Number(form.elements.quantity.value) !== quantity) throw new Error('changed');
      native = await getNative(match.record);
      resolved = core.resolve(manifest, selection, native);
      if (state.revision !== revision || !root.isConnected || Number(form.elements.quantity.value) !== quantity || !resolved.canCheckout || resolved.variantId !== reviewed.variantId || resolved.pricePence !== reviewed.pricePence) throw new Error('changed');
      const body = core.payload(resolved, quantity, data.labels, manifest.commercial, {configuration:true,access:true});
      if (!body) throw new Error('selection');
      const finalMatch = core.resolve(manifest, selection, native);
      if (!finalMatch.canCheckout || finalMatch.variantId !== resolved.variantId || finalMatch.pricePence !== resolved.pricePence) throw new Error('changed');
      cartAttempted = true;
      const response = await fetch(data.cartAddUrl + '.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      });
      if (!response.ok) throw new Error('cart');
      const result = await response.json();
      const added = result.items?.[0];
      if (!added || String(added.variant_id) !== resolved.variantId || String(added.product_id) !== resolved.record.nativeProductId) {
        display(root, null, data.strings.checkBasket);
        return;
      }
      location.assign(data.cartUrl);
    } catch (error) {
      if (state.revision === revision) display(root, null, cartAttempted ? data.strings.checkBasket : error.message === 'order-limit' ? data.strings.orderLimit : data.strings.unavailable);
    } finally { state.busy = false; }
  }, true);
  document.addEventListener('fultons:natuzzi-campaign-change', () => {
    if (data.vendor === 'Natuzzi Italia') return;
    const root = document.querySelector('#MainContent .catalogue-proof:not([hidden]),#MainContent .pdp-refined:not([hidden])');
    const state = root && records.get(root);
    if (state) { state.cancelReview?.(); state.abort?.abort(); state.revision += 1; display(root, null, data.strings.checking); }
    document.dispatchEvent(new CustomEvent('fultons:natuzzi-checkout-ready'));
  });
  window.addEventListener('pageshow', () => document.dispatchEvent(new CustomEvent('fultons:natuzzi-checkout-ready')));
  window.FultonsNatuzziCheckout = Object.freeze({ updateSelection });
  document.dispatchEvent(new CustomEvent('fultons:natuzzi-checkout-ready'));
})();

